import React, { useState, useEffect } from "react";
import "./home.css";

// Afbeeldingen importeren
import paarsevis from "../../img/paarse-vis.jpg";
import kikkerMetDuikbril from "../../img/kikker-met-duikbril.jpg";
import nijlpaard from "../../img/nijlpaard.jpg";
import marktplaats from "../../img/marktplaats.jpg";
import dee from "../../img/Dee.jpg";
import marktdees from "../../img/markt-dees.jpg";

// Willekeurige selectie van max. 3 afbeeldingen
const getRandomImages = (imagesArray, max) => {
  const shuffled = [...imagesArray].sort(() => 0.5);
  return shuffled.slice(0, max);
};

const allImages = [
  paarsevis,
  kikkerMetDuikbril,
  nijlpaard,
  marktplaats,
  dee,
  marktdees,
];
const images = getRandomImages(allImages, 3);

function Home() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-wrapper">
      {/* Carousel */}
      <div className="carousel-container">
        <img
          src={images[index]}
          alt={`Slide ${index + 1}`}
          className="carousel-image"
        />
        <div className="carousel-caption">
          <a href="../kunstgalerie" className="promo-button">
            Mijn kunstgalerie
          </a>
        </div>
        <div className="carousel-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>

      {/* Rechter kolom */}
      <div className="promo-column">
        <div className="workshop-promo">
          <img src={marktplaats} alt="Workshops" className="promo-image" />
          <div className="promo-overlay">
            <h2>Doe mee aan een workshop</h2>
            <p>Laat je creativiteit bloeien bij Keramiekmeteenknipoog</p>
            <a href="/workshops" className="promo-button">
              Bekijk workshops
            </a>
          </div>
        </div>

        <div className="workshop-promo lower-promo">
          <img src={marktdees} alt="Dee Workshop" className="promo-image" />
          <div className="promo-overlay" id="promo-overlay-lower">
            <h2>Kom meer te weten over mij!</h2>
            <p>leer mij beter kennen!</p>
            <a href="/over" className="promo-button">
              Bekijk Over mij
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
